/* @flow */
import cx from 'classnames';
import Field from 'components/Field.jsx';
import Label from 'components/Label.jsx';
import MoneyFormatter from 'lib/MoneyFormatter';
import MoneyInput from 'components/MoneyInput.jsx';
import React from 'react';
import SettingsStore from 'stores/SettingsStore';

import './styles/FormMoneyInput.scss';

const DEFAULT_MAX = 200000;
const DEFAULT_MIN = 0;

export default class FormMoneyInput extends React.Component {
  static propTypes = {
    onValidChange: React.PropTypes.func.isRequired,
    onInvalidChange: React.PropTypes.func.isRequired,
    allowZeroValue: React.PropTypes.bool,
    minimum: React.PropTypes.number,
  }

  state = {
    error: (null: ?string),
    wasBlur: false,
  }

  // $FlowFixMe destructuring
  onChange = ({ value }) => {
    const error = this.getError(value);

    if (error) {
      this.setState({ error }, () => this.props.onInvalidChange());
    } else {
      this.setState({ error: null }, () => this.props.onValidChange(value));
    }
  }

  getError(value: number) {
    const max = SettingsStore.getMaxPaymentPerPerson() || DEFAULT_MAX;
    const min = (
      this.props.minimum ||
      SettingsStore.getMinPaymentPerPerson() ||
      DEFAULT_MIN
    );

    if (value === 0 && this.props.allowZeroValue) {
      return null;
    }

    if (value < min) {
      return `Minimum amount is  ${new MoneyFormatter(min)}`;
    }

    if (value > max) {
      return `Maximum amount is ${new MoneyFormatter(max)}`;
    }

    return null;
  }

  render() {
    const error = (
      this.state.wasBlur &&
      this.state.error
    );

    return (
      <div
        className={cx('FormMoneyInput', {
          'FormMoneyInput-error': error,
        })}
        onClick={() => this.refs.input.focus()}>
        <Field error={error}>
          <Label hidden>Amount</Label>
          <MoneyInput
            {...this.props}
            ref="input"
            onChange={this.onChange}
            onBlur={() => this.setState({ wasBlur: true })}
          />
        </Field>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormMoneyInput.jsx